<template>
  <div class="btn-bottom-margin">
    <h1 class="header-style">
      Document Uploads
    </h1>
    <br>
    <p class="subheader-style">
      Please upload the below documents for completing the process
    </p>
    <upload-documents />
  </div>
</template>
<script>
import UploadDocuments from './dialogComponents/organizationsDialogs/UploadDocument.vue';
export default {
  name: 'OrganizationsRequestAcceptPage',
  components: {
    'upload-documents': UploadDocuments,
  },
  data: () => ({
  }),
};
</script>
